// import React, { useEffect, useState } from "react";
// import Modal from "react-bootstrap/Modal";
// import axios from "axios";
// import { BASE_URL } from "../../../config/axios";
// import { formattedDate, formattedDateLong, formattedDateNoYear } from "../../Date";
// import { ToastContainer, toast } from "react-toastify";
// import Select from "react-select";
// import usePermission from "../../../config/permissions";
// import { AddwithBlueCircle, AddwithWhiteCircle, CrosswithGreyCircle, CrosswithRedCircle, DropdownArrow, DropdownArrowOption } from "../../AllSvg";
// import { customSortByKey, handleAllError, handleErrorToast } from "../../CustomFunctions";
// import CreatableSelect from "react-select/creatable";
// import { AddProjectFromImprest } from "../../ImprestExpenseManagement/ImprestExpenseComponents";
// import { CSSForSelect, CSSForSelect10vWWidth, CSSForSelectAutoSize, CSSForSelectSmallWidth } from "../../CustomUtilities";

// const ExpenseAdd = ({ getExpansee }) => {

//   const { PERMISSION_AUTHORITY, PORTAL_SETTINGS } = usePermission();
//   const [allProjectList, setAllProjectList] = useState([]);
//   const [show, setShow] = useState(false);
//   const [toggleCompany, settToggleCompany] = useState(sessionStorage.getItem('company_id'));
//   const handleClose = () => {
//     setImprestExist("Existing Imprest")
//     setShow(false)
//   };
//   const handleShow = () => {
//     getAllempdata(); // Fetch all employee data
//     getDepartments()
//     getImprestTypeFormat();

//     const empCode = sessionStorage.getItem("emp_code");
//     const preSelectedOptions = allemployeedata
//       .filter(employee => employee.emp_code === empCode)
//       .map(employee => ({
//         value: employee.emp_code,
//         label: `${employee.emp_code} - ${employee.name}`
//       }));

//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       empcode: empCode,
//       multipleperson: preSelectedOptions.map(option => option.value),
//     }));

//     setSelectedOptions(preSelectedOptions); // Set default selected options in the Select component
//     setShow(true);
//   };
//   const [selectedOptions, setSelectedOptions] = useState([]);

//   const [formData, setFormData] = useState({
//     name: "",
//     imprest: "",
//     date: formattedDate,
//     empcode: sessionStorage.getItem("emp_code"),

//     project_name: "",
//     transportation: 0,
//     accomodation: 0,
//     fooding: 0,
//     approved_transportation: 0,
//     approved_accomodation: 0,
//     approved_fooding: 0,
//     other_name: "",
//     other: 0,
//     other_details: [
//       // {
//       //   other_name: "",
//       //   amount: 0,
//       //   approved_other: 0,
//       //   remaining_other: 0
//       // },
//     ],
//     no_of_days: "",
//     person: "",
//     remarks: "",
//     imprest_open: false,
//     imprest_type: "",
//   });

//   const [imprestExist, setImprestExist] = useState("Existing Imprest"); // null, true, false

//   //******************Valedation Start********************* */

//   const [errors, setErrors] = useState({});
//   const [inputState, setInputState] = useState({});
//   const [isSubmitted, setIsSubmitted] = useState(false);

//   const fieldLabels = {
//     name: "Expense Name",
//     project_name: "Imprest Name",
//     imprest: "Imprest",
//     imprest_type: "Imprest Type",
//     no_of_days: "Number of Days",
//     department: "Department",
//     ref_project_code: "Reference Project Code",
//     ref_project_name: "Reference Project Name",
//     date: "Date",
//     person: "Person"
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     const requiredFields = [
//       "name",
//       imprestExist === 'Existing Imprest' ? "imprest" : "project_name",
//       imprestExist === 'No Imprest' ? "date" : null,
//       imprestExist === 'No Imprest' ? "no_of_days" : null,
//       imprestExist === 'No Imprest' ? "imprest_type" : null,
//       imprestExist === 'No Imprest' ? formData.imprest_type === 'project-related' ? "ref_project_code" : null : null,
//       imprestExist === 'No Imprest' ? formData.imprest_type === 'project-related' ? "ref_project_name" : null : null,
//     ].filter(Boolean);

//     requiredFields.forEach((field) => {
//       if (!formData[field]) {
//         const label = fieldLabels[field] || field; // fallback if not mapped
//         newErrors[field] = `${label} is required!`;
//       }
//     });

//     setErrors(newErrors);
//     setIsSubmitted(true);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     setInputState({
//       ...inputState,
//       [name]: value.trim() ? "green" : "",
//     });

//     setFormData({
//       ...formData,
//       [name]: value,
//     });

//     if (value.trim()) {
//       setErrors((prevErrors) => {
//         const updatedErrors = { ...prevErrors };
//         delete updatedErrors[name];
//         return updatedErrors;
//       });
//     }
//   };

//   const handleImprestTypeChange = async (e) => {
//     const { name, value } = e.target;

//     setFormData({
//       ...formData,
//       [name]: value,
//       department: "",
//       // project_id: "",
//       mantra_project_id: "",
//       project_name: "",
//       ref_project_code: "",
//       ref_project_name: "",
//     });

//     setInputState({
//       ...inputState,
//       [name]: value.trim() ? "green" : "",
//       department: "",
//       // project_id: "",
//       mantra_project_id: "",
//       project_name: "",
//       ref_project_code: "",
//       ref_project_name: "",
//     });

//     setNewProject(false);

//     //  Fetch all projects when imprest type is set to "project-related"
//     if (value === "project-related") {
//       await getFilterProjects(""); // Fetch without department filter
//     } else {
//       setProjectList([]); // Clear projects for non-project-related type
//     }

//   };

//   const handleDepartmentChange = async (e) => {
//     const { name, value } = e.target;

//     setFormData({
//       ...formData,
//       [name]: value,
//       // project_id: "",
//       mantra_project_id: "",
//       project_name: "",
//       ref_project_code: "",
//       ref_project_name: "",
//     });

//     setInputState({
//       ...inputState,
//       [name]: value.trim() ? "green" : "",
//       // project_id: "",
//       mantra_project_id: "",
//       project_name: "",
//       ref_project_code: "",
//       ref_project_name: "",
//     });

//     setNewProject(false);

//     //   await getFilterProjects(value);
//     // };
//     setNewProject(false);

//     // ✅ Filter client-side from already-fetched allProjectList
//     if (value) {
//       const filtered = allProjectList.filter(
//         (p) => p.department === value || p.department === null
//       );
//       setProjectList(filtered);
//     } else {
//       setProjectList(allProjectList); // no department → show all
//     }
//   };

//   const handleOtherInputChange = (index, e) => {
//     const { name, value } = e.target;
//     setFormData((prevFormData) => {
//       const newOthers = [...prevFormData.other_details];
//       newOthers[index] = {
//         ...newOthers[index],
//         [name]: value,
//       };
//       return {
//         ...prevFormData,
//         other_details: newOthers,
//       };
//     });
//   };

//   const handleAddOthers = () => {
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       other_details: [
//         ...prevFormData.other_details,
//         {
//           other_name: "",
//           amount: 0,
//           approved_other: 0,
//           remaining_other: 0,
//         },
//       ],
//     }));
//   };

//   const handleRemoveOthers = (index) => {
//     setFormData((prevFormData) => {
//       const newOthers = [...prevFormData.other_details];
//       newOthers.splice(index, 1);
//       return {
//         ...prevFormData,
//         other_details: newOthers,
//       };
//     });
//   };

//   //******************Valedation End*********************** */

//   const [loading, setLoading] = useState(false); //loading logic

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();
//     const updatedFormData = {
//       ...formData,
//       person: formData?.multipleperson?.length,
//       imprest_open: true,
//       rh_leave_status: 'approved',
//       admin_leave_status: 'approved',
//       account_leave_status: 'approved',
//       amount_change_reason: 'Confirmed',
//     };
//     if (validateForm()) {
//       setLoading(true); //loading logic
//       const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
//       try {
//         const url = imprestExist === 'Existing Imprest'
//           ? `${BASE_URL}/wfm/expense/`
//           : `${BASE_URL}/wfm/createImprestAndExpense/`;

//         const data = imprestExist === 'Existing Imprest' ? formData : updatedFormData;
//         let res = await axios.post(url, data);

//         if (res.status === 200) {
//           if (imprestExist === 'Existing Imprest') {
//             try {
//               let imp = await axios.put(`${BASE_URL}/wfm/imprest/${formData.imprest}/`, {
//                 imprest_open: false
//               });
//               if (imp.status === 200) {
//                 await getExpansee();
//                 await getAllempdata();
//                 setFormData({
//                   name: "",
//                   imprest: "",
//                   date: formattedDate,
//                   empcode: sessionStorage.getItem("emp_code")
//                 });
//                 setShow(false);
//               } else {
//                 console.log("Imprest Closing Error");
//                 alert("Error closing imprest: " + imp.statusText);
//               }
//             } catch (error) {
//               console.error('Error updating imprest:', error);
//               alert("Error closing imprest: " + error.message);
//             }
//           } else {
//             await getExpansee();
//             await getAllempdata();
//             setFormData({
//               name: "",
//               imprest: "",
//               date: formattedDate,
//               empcode: sessionStorage.getItem("emp_code")
//             });
//             // setShow(false);
//             handleClose();
//           }
//         } else {
//           console.log("Expense Creation Error");
//           // alert("Error creating expense: " + res.statusText);
//         }

//       } catch (err) {
//         handleAllError(err, loadingToastId)
//       } finally {
//         setLoading(false); //loading logic
//         toast.dismiss(loadingToastId);
//       }
//     }
//   };

//   useEffect(() => {
//     getAllempdata();
//   }, [imprestExist]);

//   const [buffer1, setBuffering1] = useState(true);
//   const [departmentLists, setDepartmentLists] = useState([]);
//   const getDepartments = async () => {
//     try {
//       setBuffering1(true)
//       const dep = await axios.get(`${BASE_URL}/wfm/departmentfilterbysubcompanycount/${sessionStorage.getItem('company_id') || 'null'}/active/`);
//       setDepartmentLists(dep.data)
//     } catch (err) {
//     } finally {
//       setBuffering1(false)
//     }
//   };

//   const [allemployeeImprest, setAllemployeeImprest] = useState([]);
//   const [allemployeedata, setAllemployee] = useState([]);

//   const getAllempdata = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/wfm/imprestbyemployeedetails/${sessionStorage.getItem("emp_code")}/`);
//       setAllemployeeImprest(res.data);

//       const emp = await axios.get(
//         PERMISSION_AUTHORITY ?
//           `${BASE_URL}/wfm/ourcompanyempdetailsactive/null/`
//           :
//           `${BASE_URL}/wfm/ourcompanyempdetailsactive/${sessionStorage.getItem("company_id")}/`
//       );

//       const sortedList = customSortByKey(emp.data, "emp_code");

//       setAllemployee(sortedList);

//     } catch (err) {
//       handleErrorToast(err);
//     }
//   };

//   const [projectList, setProjectList] = useState([]);
//   const [buffer, setBuffering] = useState(false); //buffering logic
//   // const getFilterProjects = async (department) => {
//   //   setBuffering(true); // Start Buffering
//   //   try {
//   //     let url = "";

//   //     if (department === "Prebid") {
//   //       url = `${BASE_URL}/project/projectfilterbysubcompany/null/`;
//   //     } else if (department === "Site") {
//   //       url = `${BASE_URL}/siteproject/project/`;
//   //     } else if (department !== "") {
//   //       url = `${BASE_URL}/wfm/projectcode/${department}/${sessionStorage.getItem("company_id")}/`;
//   //     }

//   //     else {
//   //       setProjectList([]);
//   //       setBuffering(false);
//   //       return;
//   //     }

//   //     const res = await axios.get(url);
//   //     setProjectList(res.data || []);
//   //   } catch (err) {
//   //     handleErrorToast(err);
//   //   } finally {
//   //     setBuffering(false); // End Buffering
//   //   }
//   // };

//   // const getFilterProjects = async (department) => {
//   //   setBuffering(true);
//   //   try {
//   //     // Build URL dynamically - department_id is optional
//   //     let url = `${BASE_URL}/mantra_projects/projects/?sub_company_id=${sessionStorage.getItem("company_id")}`;
//   //     if (department) {
//   //       url += `&department_id=${department}`;
//   //     }

//   //     const res = await axios.get(url);
//   //     setProjectList(res.data || []);
//   //   } catch (err) {
//   //     handleErrorToast(err);
//   //   } finally {
//   //     setBuffering(false);
//   //   }
//   // };
//   const getFilterProjects = async (department) => {
//     setBuffering(true);
//     try {
//       // Always fetch ALL projects for this sub_company (no department filter on API)
//       const url = `${BASE_URL}/mantra_projects/projects/?sub_company_id=${toggleCompany}`;
//       const res = await axios.get(url);
//       const data = res.data || [];

//       setAllProjectList(data); // ✅ store full list

//       // ✅ Filter client-side if department is selected
//       if (department) {
//         const filtered = data.filter(
//           (p) => p.department === department || p.department === null
//         );
//         setProjectList(filtered);
//       } else {
//         setProjectList(data); // no filter → show all
//       }
//     } catch (err) {
//       handleErrorToast(err);
//     } finally {
//       setBuffering(false);
//     }
//   };

//   const options = allemployeedata
//     .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
//     .map((e) => ({
//       value: e.emp_code,
//       label: `${e.emp_code} - ${e.name}`,
//     }));

//   // const handleChangecc = (selected) => {
//   //   // const multipleperson = selected ? selected.map((item) => item.value) : [];

//   //   const multipleperson = selected.length > 0 ? selected.map((item) => item.value) : "";
//   //   setFormData((prevState) => ({
//   //     ...prevState,
//   //     multipleperson,
//   //   }));
//   // };

//   console.log(projectList, "list");

//   const handleChangecc = (selected) => {
//     const multipleperson = selected.length > 0 ? selected.map((item) => item.value) : "";
//     setSelectedOptions(selected); // Update selected options state
//     setFormData((prevState) => ({
//       ...prevState,
//       multipleperson,
//     }));
//   };

//   // const handleProjectChange = (selectedOption) => {
//   //   if (selectedOption) {
//   //     const selectedProject = projectList.find(
//   //       (project) =>
//   //         project.prebid_prcode === selectedOption.value ||
//   //         project.site_prcode === selectedOption.value ||
//   //         project.project_code === selectedOption.value
//   //     );

//   //     if (selectedProject) {
//   //       const fullProjectName =
//   //         formData.department === "Prebid"
//   //           ? `${selectedProject.prebid_prcode}-${selectedProject.project_short_name}`
//   //           : formData.department === "Site"
//   //             ? `${selectedProject.site_prcode}-${selectedProject.project_short_name}`
//   //             : `${selectedProject.project_code}-${selectedProject.project_name}`;

//   //       setFormData({
//   //         ...formData,
//   //         // project_id: selectedProject.id, // Assigning UUID from projectList
//   //         project_id: formData.department === "Prebid"
//   //           ? selectedProject.pr_code
//   //           : selectedProject.id,
//   //         project_name: fullProjectName,
//   //         ref_project_code:
//   //           formData.department === "Prebid"
//   //             ? selectedProject.prebid_prcode
//   //             : formData.department === "Site"
//   //               ? selectedProject.site_prcode
//   //               : selectedProject.project_code,
//   //         ref_project_name:
//   //           formData.department === "Prebid"
//   //             ? selectedProject.project_short_name
//   //             : formData.department === "Site"
//   //               ? selectedProject.project_short_name
//   //               : selectedProject.project_name,
//   //       });

//   //       setInputState({
//   //         ...inputState,
//   //         project_id: "green",
//   //         project_name: "green",
//   //         ref_project_code: "green",
//   //         ref_project_name: "green",
//   //       });
//   //     }
//   //   }
//   // };
//   const handleProjectChange = (selectedOption) => {
//     if (!selectedOption) {
//       setFormData({
//         ...formData,
//         // project_id: "",
//         mantra_project_id: "",
//         project_name: "",
//         ref_project_code: "",
//         ref_project_name: "",
//       });
//       return;
//     }

//     // ✅ Match only by project_code
//     const selectedProject = projectList.find(
//       (project) => project.project_code === selectedOption.value
//     );

//     if (selectedProject) {
//       // ✅ Always use project_code and project_short_name
//       const fullProjectName = `${selectedProject.project_code}-${selectedProject.project_short_name}`;

//       setFormData({
//         ...formData,
//         // project_id: selectedProject.id,
//         mantra_project_id: selectedProject.id,
//         project_name: fullProjectName,
//         ref_project_code: selectedProject.project_code,       // ✅ consistent key
//         ref_project_name: selectedProject.project_short_name, // ✅ consistent key
//       });

//       setInputState({
//         ...inputState,
//         // project_id: "green",
//         mantra_project_id: "green",
//         project_name: "green",
//         ref_project_code: "green",
//         ref_project_name: "green",
//       });
//     }
//   };

//   const handleNoProjectChange = (inputValue) => {
//     if (!inputValue) return;

//     setFormData({
//       ...formData,
//       // project_id: '',
//       mantra_project_id: "",
//       project_name: inputValue,
//       ref_project_code: inputValue,
//       ref_project_name: inputValue,
//     });

//     setInputState({
//       ...inputState,
//       // project_id: "green",
//       mantra_project_id: "green",
//       project_name: "green",
//       ref_project_code: "green",
//       ref_project_name: "green",
//     });
//   };

//   const [newProject, setNewProject] = useState(false);

//   const getImprestTypeFormat = async () => {
//     try {
//       setBuffering(true);
//       const res = await axios.get(`${BASE_URL}/wfm/imprest_type_format_subcompany/${toggleCompany}/`);

//       const formattedFormatData = res.data.map(item => ({
//         other_name: item.other_name || "",
//         amount: item.amount || 0,
//         approved_other: item.approved_other || 0,
//       }));

//       setFormData({
//         ...formData,
//         other_details: formattedFormatData,
//       });

//     } catch (error) {
//       console.error(error);
//       // handleErrorToast(error)
//     } finally {
//       setBuffering(false);
//     }
//   }

//   const projectOptions = projectList.map((data) => ({

//     value: data.project_code,
//     label: `${data.project_code} - ${data.project_short_name}`,
//   }));

//   return (
//     <>
//       <button className="upload-svg" onClick={handleShow}>
//         <AddwithWhiteCircle />{" "}Expense
//       </button>

//       <Modal show={show} onHide={handleClose} dialogClassName={imprestExist === "No Imprest" ? "ourcompany-model" : "request-leave width-40vw"}>
//         {/* <Modal.Header closeButton>
//           <Modal.Title>Request Leave</Modal.Title>
//         </Modal.Header> */}
//         <Modal.Body>
//           <div className="parent-div">
//             <div className="form-flex-wrap">

//               {imprestExist === "No Imprest" &&
//                 <div className="flex-column">
//                   <label
//                     htmlFor="project_name"
//                     className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
//                   >
//                     Imprest Name<span className="required">*</span>
//                   </label>
//                   {buffer ?
//                     <div className="form-loader">
//                       <div className="bar-loader"></div>
//                     </div>
//                     :
//                     <>
//                       <input
//                         id="project_name"
//                         type="text"
//                         name="project_name"
//                         placeholder="Imprest Name"
//                         onChange={handleInputChange}
//                         value={formData.project_name}
//                         className={`form-input ${errors.project_name
//                           ? "error"
//                           : inputState.project_name
//                             ? "success"
//                             : ""
//                           }`}
//                       />
//                       {errors.project_name && (
//                         <span className="error-message font-size-text ">{errors.project_name}</span>
//                       )}
//                     </>}
//                 </div>}

//               <div className="flex-column">
//                 <label htmlFor="name" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
//                   Expense Name<span className="required">*</span>
//                 </label>
//                 <input
//                   id="name"
//                   type="name"
//                   name="name"
//                   placeholder="Expense Name"
//                   onChange={handleInputChange}
//                   value={formData.name}
//                   className={`form-input ${errors.name ? "error" : inputState.name ? "success" : ""
//                     }`}
//                 />
//                 {errors.name && (
//                   <span className="error-message font-size-text ">{errors.name}</span>
//                 )}
//               </div>
//             </div>

//             <div >
//               <div className="leave-duration-tabs" style={{ width: "96%", position: "relative", display: "flex", marginBottom: "15px" }}>
//                 <input
//                   type="radio"
//                   id="imprest-existing"
//                   name="imprest_exist"
//                   value="Existing Imprest"
//                   checked={imprestExist === "Existing Imprest"}
//                   onChange={(e) => setImprestExist(e.target.value)}
//                   hidden
//                 />
//                 <label htmlFor="imprest-existing" className="leave-tab" style={{ flex: 1, textAlign: "center" }}>
//                   Existing Imprest
//                 </label>

//                 <input
//                   type="radio"
//                   id="imprest-no"
//                   name="imprest_exist"
//                   value="No Imprest"
//                   checked={imprestExist === "No Imprest"}

//                   onChange={(e) => setImprestExist(e.target.value)}
//                   hidden
//                 />
//                 <label htmlFor="imprest-no" className="leave-tab" style={{ flex: 1, textAlign: "center" }}>
//                   No Imprest
//                 </label>

//                 <span
//                   className="leave-tab-glider"
//                   style={{
//                     transform: imprestExist === "Existing Imprest" ? "translateX(0%)" : "translateX(100%)",
//                     width: "50%"
//                   }}
//                 ></span>
//               </div>

//               {imprestExist === "Existing Imprest" ?
//                 <>
//                   <div className="flex-column">
//                     <label className="form-labels  font-weight500    font-size-subheading">
//                       Against Imprest<span className="required">*</span>
//                     </label>
//                     <select
//                       name="imprest"
//                       onChange={handleInputChange}
//                       value={formData.imprest}
//                       className={`form-input ${errors.imprest ? "error" : inputState.imprest ? "success" : ""
//                         }`}>
//                       <option value="">Select imprest</option>
//                       {/* {allemployeeImprest.filter((imprest) => imprest.imprest_open === true)
//                         .map((e, index) => (
//                           <option value={e.id}>{e.project_name} - {formattedDateLong(e.date)}</option>
//                         ))} */}

//                       {allemployeeImprest
//                         .filter(imprest => imprest.imprest_open === true)
//                         .map((e) => {
//                           const imprestDate = new Date(e.apply_datetime || e.date);
//                           const today = new Date();
//                           const timeDiff = today - imprestDate;
//                           const daysPassed = Math.floor(timeDiff / (1000 * 60 * 60 * 24));

//                           let submissionNote = '';
//                           let noteClass = ''; // <-- Class for styling

//                           if (PORTAL_SETTINGS?.expense_submit_limit) {
//                             const limit = PORTAL_SETTINGS.expense_submit_limit_days;

//                             if (daysPassed < limit) {
//                               const daysRemaining = limit - daysPassed;
//                               submissionNote = `(${daysRemaining} day${daysRemaining > 1 ? 's' : ''} left)`;
//                               noteClass = "approved";
//                               // noteClass = true;
//                             } else if (daysPassed === limit) {
//                               submissionNote = `(Last day to submit)`;
//                               noteClass = "pending";
//                               // noteClass = true;
//                             } else {
//                               const daysLate = daysPassed - limit;
//                               submissionNote = `(${daysLate} day${daysLate > 1 ? 's' : ''} late)`;
//                               noteClass = "rejected";
//                               // noteClass = false;
//                             }
//                           }

//                           return (
//                             <option key={e.id} value={e.id} title={`days limit : ${PORTAL_SETTINGS?.expense_submit_limit_days} day(s)`} className='request-status' request-status={noteClass} >
//                               {e.project_name} - {formattedDateLong(e.date)
//                               }{" "}
//                               {submissionNote && <span> {submissionNote}</span>}
//                             </option>
//                           );
//                         })}
//                     </select>
//                     {errors.imprest && (
//                       <span className="error-message font-size-text ">{errors.imprest}</span>
//                     )}
//                   </div>

//                 </>
//                 :
//                 <>
//                   <div className="form-flex-wrap">
//                     <div className="flex-column">
//                       <label htmlFor="date" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
//                         Date<span className="required">*</span>
//                       </label>
//                       <input
//                         id="date"
//                         type="date"
//                         name="date"
//                         onChange={handleInputChange}
//                         value={formData.date}
//                         className={`form-input ${errors.date ? "error" : inputState.date ? "success" : ""
//                           }`}
//                       />
//                       {errors.date && (
//                         <span className="error-message font-size-text ">{errors.date}</span>
//                       )}
//                     </div>

//                     <div className="flex-column">
//                       <label
//                         htmlFor="imprest_type"
//                         className="form-labels font-weight500 announce-date"
//                       >
//                         Imprest Type<span className="required">*</span>
//                       </label>

//                       <select
//                         name="imprest_type"
//                         onChange={(e) => handleImprestTypeChange(e)}
//                         value={formData.imprest_type}
//                         className={`form-input`}
//                       >
//                         <option value="">Select Type of Imprest</option>
//                         <option value="non-project-related">Not Related to a Project</option>
//                         <option value="project-related">Project Related</option>
//                       </select>
//                       {errors.imprest_type && (
//                         <span className="error-message font-size-text ">{errors.imprest_type}</span>
//                       )}
//                     </div>

//                     {formData.imprest_type === 'project-related' &&
//                       <div className="flex-column">
//                         <label
//                           htmlFor="department"
//                           className="form-labels font-weight500 announce-date"
//                         >
//                           Department
//                         </label>
//                         {buffer1 ?
//                           <div className="form-loader">
//                             <div className="bar-loader"></div>
//                           </div>
//                           :
//                           <>
//                             <select
//                               name="department"
//                               onChange={(e) => handleDepartmentChange(e)}
//                               value={formData.department}
//                               className={`form-input-date`}
//                             >
//                               <option value="">Select Department for Projects</option>
//                               {sessionStorage.getItem('company_id') === '025d0b52-e892-4868-a3bb-6b70dcdffb4d' ?
//                                 <option value="Prebid">Prebid</option>
//                                 : null}
//                               {/* <option value="Site">Site</option> */}
//                               {departmentLists
//                                 .sort((a, b) => a.title.localeCompare(b.title))
//                                 .map((i, index) => (
//                                   // <option value={i.id}>{i.title}</option>
//                                   <option key={i.id} value={i.id}>{i.title}</option>

//                                 ))};
//                             </select>
//                             {/* <DropdownArrow /> */}
//                           </>}
//                         {errors.department && (
//                           <span className="error-message font-size-text">
//                             {errors.department}
//                           </span>
//                         )}
//                       </div>}

//                     {formData.imprest_type === 'project-related' && (
//                       <div className="flex-column form-group-select">
//                         <label
//                           htmlFor="ref_project_code"
//                           className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
//                         >
//                           For {departmentLists.find(t => t.id === formData.department)?.title || ""}  Project <span className="required">*</span>
//                         </label>

//                         {buffer ? (
//                           <div className="form-loader">
//                             <div className="bar-loader"></div>
//                           </div>
//                         ) : (
//                           <>
//                             <CreatableSelect
//                               id="ref_project_code"
//                               name="ref_project_code"
//                               options={projectOptions}
//                               // options={projectList.map(data => ({
//                               //   value: data.project_code,   //  single key
//                               //   label: `${data.project_code} - ${data.project_short_name}`,
//                               // value:
//                               //   formData.department === 'Prebid'
//                               //     ? data.prebid_prcode
//                               //     : formData.department === 'Site'
//                               //       ? data.site_prcode
//                               //       : data.project_code,
//                               // label:
//                               //   formData.department === 'Prebid'
//                               //     ? data.prebid_prcode
//                               //     : formData.department === 'Site'
//                               //       ? data.site_prcode
//                               //       : data.project_code,
//                               // }))}
//                               onChange={handleProjectChange}
//                               // onChange={(selectedOption) => {
//                               //   setNewProject(false);
//                               //   handleProjectChange(selectedOption);
//                               // }}
//                               // {...(formData.department !== 'Prebid' && formData.department !== 'Site'
//                               //   ? {
//                               //     onCreateOption: (inputValue) => {
//                               //       setNewProject(true);
//                               //       handleNoProjectChange(inputValue);
//                               //     },
//                               //   }
//                               //   : {})}
//                               // value={
//                               //   formData.ref_project_code
//                               //     ? {
//                               //       value: formData.ref_project_code,
//                               //       label: formData.ref_project_code
//                               //     }
//                               //     : null
//                               // }
//                               value={
//                                 formData.ref_project_code
//                                   ? {
//                                     value: formData.ref_project_code,
//                                     label:
//                                       projectOptions.find(
//                                         (o) => o.value === formData.ref_project_code
//                                       )?.label || formData.ref_project_code,
//                                   }
//                                   : null
//                               }
//                               // value={
//                               //   formData.ref_project_code
//                               //     ? {
//                               //       value: formData.ref_project_code,
//                               //       label: formData.ref_project_code, // Ensure the label matches what should be displayed
//                               //     }
//                               //     : null
//                               // }
//                               placeholder="Project Code"
//                               isClearable
//                               // isDisabled={!formData.department}
//                               noOptionsMessage={() =>
//                                 projectList.length === 0
//                                   ? "No projects found. Contact Admin to add project."
//                                   : "No matching project"
//                               }
//                               // noOptionsMessage={() =>
//                               //   formData.department
//                               //     ? "No projects found. Contact Admin to add project."
//                               //     : "Select a department first"
//                               // }
//                               // className="form-input-date"
//                               styles={CSSForSelectAutoSize}
//                             />
//                             {projectList.length === 0 && !buffer && (
//                               <span
//                                 className="form-hint font-size-text"
//                                 style={{ color: "#888", marginTop: "4px" }}
//                               >
//                                 No projects found. Please contact Admin to add a project.
//                               </span>
//                             )}
//                             {/* {formData.department && projectList.length === 0 && !buffer && (
//                               <span className="form-hint font-size-text" style={{ color: "#888" }}>
//                                 No projects in this department. Please contact Admin to add a project.
//                               </span>
//                             )} */}
//                           </>
//                         )}

//                         {errors.ref_project_code && (
//                           <span className="error-message font-size-text">
//                             {errors.ref_project_code}
//                           </span>
//                         )}
//                       </div>
//                     )}

//                     {formData.imprest_type === 'project-related' && (
//                       <div className="flex-column">
//                         <label
//                           htmlFor="ref_project_name"
//                           className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
//                         >
//                           Project Name<span className="required">*</span>
//                         </label>
//                         {buffer ?
//                           <div className="form-loader">
//                             <div className="bar-loader"></div>
//                           </div>
//                           :
//                           <>
//                             <input
//                               id="ref_project_name"
//                               type="text"
//                               name="ref_project_name"
//                               // placeholder="Project Name"
//                               placeholder="Auto-filled on project selection"
//                               readOnly
//                               style={{ cursor: "not-allowed", backgroundColor: "#f5f5f5" }}
//                               // onChange={handleInputChange}
//                               value={formData.ref_project_name}
//                               className={`form-input ${errors.ref_project_name
//                                 ? "error"
//                                 : inputState.ref_project_name
//                                   ? "success"
//                                   : ""
//                                 }`}
//                             />
//                             {errors.ref_project_name && (
//                               <span className="error-message font-size-text">
//                                 {errors.ref_project_name}
//                               </span>
//                             )}
//                           </>}
//                       </div>)}

//                     {/* {
//                       newProject === true ?
//                         <AddProjectFromImprest
//                           i={formData}
//                           departmentLists={departmentLists}
//                           getFilterProjects={getFilterProjects}
//                           setFormData={setFormData}
//                           setInputState={setInputState}
//                           setNewProject={setNewProject}
//                         />
//                         :
//                         null
//                     } */}

//                   </div>
//                   <hr className="line" />

//                   <div className="form-flex-wrap">
//                     {formData.other_details.map((other, index) => (
//                       <>
//                         <div className="flex-column">
//                           <div className="flex-row">
//                             <div className="flex-column">
//                               <label htmlFor={`other_name_${index}`} className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
//                                 Expense Name
//                               </label>
//                             </div >
//                             {index !== 0 && (
//                               <div className="">
//                                 <button type='button' title="Remove" className="align-center flex-row action-div" onClick={() => handleRemoveOthers(index)}>
//                                   <CrosswithRedCircle />
//                                 </button>
//                               </div>
//                             )}
//                           </div>
//                           <input
//                             id={`other_name_${index}`}
//                             type="text"
//                             name="other_name"
//                             placeholder="Other Expense Name"
//                             onChange={(e) => handleOtherInputChange(index, e)}
//                             value={other.other_name}
//                             className={`form-input`}
//                           />
//                         </div>
//                       </>
//                     ))}
//                   </div>

//                   {/* <hr className="line" /> */}
//                   <div className="flex-row">
//                     <hr className="line" />
//                     <button type='button' title="Add Document" className=" flex-row jd-heading-main font-weight600 gap-2" onClick={handleAddOthers}>
//                       <AddwithBlueCircle /> <span className="w-max-content">Expense Type</span>
//                     </button>
//                   </div>

//                   <div className="form-flex-wrap">
//                     <div className="flex-column">
//                       <label
//                         htmlFor="no_of_days"
//                         className="form-labels  font-weight500    announce-date font-weight400  font-size-heading"
//                       >
//                         Number of days<span className="required">*</span>
//                       </label>
//                       <input
//                         id="no_of_days"
//                         type="number"
//                         min={0}
//                         placeholder="Days"
//                         name="no_of_days"
//                         onWheel={(e) => e.target.blur()}
//                         onChange={handleInputChange}
//                         value={formData.no_of_days}
//                         className={`form-input ${errors.no_of_days
//                           ? "error"
//                           : inputState.no_of_days
//                             ? "success"
//                             : ""
//                           }`}
//                       />
//                       {errors.no_of_days && (
//                         <span className="error-message font-size-text ">{errors.no_of_days}</span>
//                       )}
//                     </div>

//                     <div className="flex-column">
//                       <label htmlFor="person" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
//                         Name of Person
//                       </label>

//                       {/* <Select options={options} isMulti onChange={handleChangecc} /> */}
//                       <Select
//                         options={options}
//                         isMulti
//                         value={selectedOptions}
//                         onChange={handleChangecc}
//                         styles={CSSForSelect}
//                       />

//                       {errors.person && (
//                         <span className="error-message font-size-text ">{errors.person}</span>
//                       )}
//                     </div>

//                     <div className="flex-column">
//                       <label htmlFor="person" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
//                         Number's of Person (Auto)
//                       </label>
//                       <input
//                         id="person"
//                         type="number"
//                         name="person"
//                         // onChange={handleInputChange}
//                         readOnly
//                         value={formData.multipleperson?.length}
//                         className={`form-input ${errors.person ? "error" : inputState.person ? "success" : ""
//                           }`}
//                       />
//                       {errors.person && (
//                         <span className="error-message font-size-text ">{errors.person}</span>
//                       )}
//                     </div>

//                     <div className="flex-column">
//                       <label htmlFor="remarks" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
//                         Remarks
//                       </label>
//                       <textarea
//                         id="remarks"
//                         type="text"
//                         name="remarks"
//                         placeholder="Your feedback"
//                         onChange={handleInputChange}
//                         // maxLength={200}
//                         value={formData.remarks}
//                         className={`form-input-textarea   font-weight400  font-size-subheading ${errors.remarks
//                           ? "error"
//                           : inputState.remarks
//                             ? "success"
//                             : ""
//                           }`}
//                       />
//                       {errors.remarks && (
//                         <span className="error-message font-size-text ">{errors.remarks}</span>
//                       )}
//                     </div>
//                   </div>
//                 </>
//               }

//             </div>

//             {/* {newProject === true ? */}
//             {/* // <span className="align-center required">
//               //   Note : Unrecognized Project Code entered — Add Project first.
//               //   <br />
//               //   <AddProjectFromImprest
//               //     i={formData}
//               //     departmentLists={departmentLists}
//               //     getFilterProjects={getFilterProjects}
//               //     setFormData={setFormData}
//               //     setInputState={setInputState}
//               //     setNewProject={setNewProject}
//               //   />
//               // </span>
//               // : */}
//             <div className="button-models">
//               <button className="model-button model-button-cancel   font-weight500   " onClick={handleClose}>
//                 Cancel
//               </button>
//               <button
//                 type="submit"
//                 className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
//                 onClick={handleFormSubmit}
//                 disabled={loading}
//               >
//                 Add
//               </button>
//             </div>
//             {/* } */}
//             <p className="error-message font-size-text">
//               {isSubmitted && Object.keys(errors).length > 0 && (
//                 Object.keys(errors).length > 5 ? (
//                   <h5 className="text-center">Please fill all mandatory fields!</h5>
//                 ) : (
//                   <h6 className="text-center">
//                     {Object.keys(errors)
//                       .map((field) =>
//                         field
//                           .replace(/_/g, ' ')
//                           .replace(/\b\w/g, (char) => char.toUpperCase())
//                       )
//                       .join(', ') + ' are required!'}
//                   </h6>
//                 )
//               )}
//             </p>
//           </div>
//           <ToastContainer
//             position="top-center"
//             hideProgressBar={false}
//             newestOnTop={true}
//             closeOnClick
//             rtl={false}
//             pauseOnFocusLoss
//             draggable
//             pauseOnHover
//           />
//         </Modal.Body>
//       </Modal >
//     </>
//   );
// };

// export { ExpenseAdd };

import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { BASE_URL } from "../../../config/axios";
import {
  formattedDate,
  formattedDateLong,
  formattedDateNoYear,
} from "../../Date";
import { ToastContainer, toast } from "react-toastify";
import Select from "react-select";
import usePermission from "../../../config/permissions";
import {
  AddwithBlueCircle,
  AddwithWhiteCircle,
  CrosswithGreyCircle,
  CrosswithRedCircle,
  DropdownArrow,
  DropdownArrowOption,
} from "../../AllSvg";
import {
  customSortByKey,
  handleAllError,
  handleErrorToast,
} from "../../CustomFunctions";
import CreatableSelect from "react-select/creatable";
import { AddProjectFromImprest } from "../../ImprestExpenseManagement/ImprestExpenseComponents";
import {
  CSSForSelect,
  CSSForSelect10vWWidth,
  CSSForSelectAutoSize,
  CSSForSelectSmallWidth,
} from "../../CustomUtilities";

const ExpenseAdd = ({ getExpansee }) => {
  const { PERMISSION_AUTHORITY, PORTAL_SETTINGS } = usePermission();
  const [allProjectList, setAllProjectList] = useState([]);
  const [show, setShow] = useState(false);
  const [toggleCompany, settToggleCompany] = useState(
    sessionStorage.getItem("company_id"),
  );
  const handleClose = () => {
    setImprestExist("Existing Imprest");
    // clear formData and errors
    setFormData({
      name: "",
      imprest: "",
      date: formattedDate,
      empcode: sessionStorage.getItem("emp_code"),
      project_name: "",
      transportation: 0,
      accomodation: 0,
      fooding: 0,
      approved_transportation: 0,
      approved_accomodation: 0,
      approved_fooding: 0,
      other_name: "",
      other: 0,
      other_details: [],
      no_of_days: "",
      person: "",
      remarks: "",
      imprest_open: false,
      imprest_type: "",
    });
    setErrors({});
    setShow(false);
  };
  const handleShow = () => {
    getAllempdata(); // Fetch all employee data
    getDepartments();
    getImprestTypeFormat();

    const empCode = sessionStorage.getItem("emp_code");
    const preSelectedOptions = allemployeedata
      .filter((employee) => employee.emp_code === empCode)
      .map((employee) => ({
        value: employee.emp_code,
        label: `${employee.emp_code} - ${employee.name}`,
      }));

    setFormData((prevFormData) => ({
      ...prevFormData,
      empcode: empCode,
      multipleperson: preSelectedOptions.map((option) => option.value),
    }));

    setSelectedOptions(preSelectedOptions); // Set default selected options in the Select component
    setShow(true);
  };
  const [selectedOptions, setSelectedOptions] = useState([]);

  const [formData, setFormData] = useState({
    name: "",
    imprest: "",
    date: formattedDate,
    empcode: sessionStorage.getItem("emp_code"),

    project_name: "",
    transportation: 0,
    accomodation: 0,
    fooding: 0,
    approved_transportation: 0,
    approved_accomodation: 0,
    approved_fooding: 0,
    other_name: "",
    other: 0,
    other_details: [],
    no_of_days: "",
    person: "",
    remarks: "",
    imprest_open: false,
    imprest_type: "",
  });

  const [imprestExist, setImprestExist] = useState("Existing Imprest"); // null, true, false

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const fieldLabels = {
    name: "Expense Name",
    project_name: "Imprest Name",
    imprest: "Imprest",
    imprest_type: "Imprest Type",
    no_of_days: "Number of Days",
    department: "Department",
    ref_project_code: "Reference Project Code",
    ref_project_name: "Reference Project Name",
    date: "Date",
    person: "Person Name",
  };

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "name",
      imprestExist === "Existing Imprest" ? "imprest" : "project_name",
      imprestExist === "No Imprest" ? "date" : null,
      imprestExist === "No Imprest" ? "no_of_days" : null,
      imprestExist === "No Imprest" ? "imprest_type" : null,
      imprestExist === "No Imprest" ? "person" : null, // Validation added for person name
      imprestExist === "No Imprest"
        ? formData.imprest_type === "project-related"
          ? "ref_project_code"
          : null
        : null,
      imprestExist === "No Imprest"
        ? formData.imprest_type === "project-related"
          ? "ref_project_name"
          : null
        : null,
    ].filter(Boolean);

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        const label = fieldLabels[field] || field; // fallback if not mapped
        newErrors[field] = `${label} is required!`;
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });

    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  const handleImprestTypeChange = async (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
      department: "",
      mantra_project_id: "",
      project_name: "",
      ref_project_code: "",
      ref_project_name: "",
    });

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
      department: "",
      mantra_project_id: "",
      project_name: "",
      ref_project_code: "",
      ref_project_name: "",
    });

    setNewProject(false);

    if (value === "project-related") {
      await getFilterProjects("");
    } else {
      setProjectList([]);
    }
  };

  const handleDepartmentChange = async (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
      mantra_project_id: "",
      project_name: "",
      ref_project_code: "",
      ref_project_name: "",
    });

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
      mantra_project_id: "",
      project_name: "",
      ref_project_code: "",
      ref_project_name: "",
    });

    setNewProject(false);

    if (value) {
      const filtered = allProjectList.filter(
        (p) => p.department === value || p.department === null,
      );
      setProjectList(filtered);
    } else {
      setProjectList(allProjectList);
    }
  };

  const handleOtherInputChange = (index, e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      const newOthers = [...prevFormData.other_details];
      newOthers[index] = {
        ...newOthers[index],
        [name]: value,
      };
      return {
        ...prevFormData,
        other_details: newOthers,
      };
    });
  };

  const handleAddOthers = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      other_details: [
        ...prevFormData.other_details,
        {
          other_name: "",
          amount: 0,
          approved_other: 0,
          remaining_other: 0,
        },
      ],
    }));
  };

  const handleRemoveOthers = (index) => {
    setFormData((prevFormData) => {
      const newOthers = [...prevFormData.other_details];
      newOthers.splice(index, 1);
      return {
        ...prevFormData,
        other_details: newOthers,
      };
    });
  };

  const [loading, setLoading] = useState(false);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const updatedFormData = {
      ...formData,
      person: formData?.multipleperson?.length || "",
      imprest_open: true,
      rh_leave_status: "approved",
      admin_leave_status: "approved",
      account_leave_status: "approved",
      amount_change_reason: "Confirmed",
    };
    if (validateForm()) {
      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please wait...");
      try {
        const url =
          imprestExist === "Existing Imprest"
            ? `${BASE_URL}/wfm/expense/`
            : `${BASE_URL}/wfm/createImprestAndExpense/`;

        const data =
          imprestExist === "Existing Imprest" ? formData : updatedFormData;
        let res = await axios.post(url, data);

        if (res.status === 200) {
          if (imprestExist === "Existing Imprest") {
            try {
              let imp = await axios.put(
                `${BASE_URL}/wfm/imprest/${formData.imprest}/`,
                {
                  imprest_open: false,
                },
              );
              if (imp.status === 200) {
                await getExpansee();
                await getAllempdata();
                setFormData({
                  name: "",
                  imprest: "",
                  date: formattedDate,
                  empcode: sessionStorage.getItem("emp_code"),
                });
                setShow(false);
              } else {
                console.log("Imprest Closing Error");
                alert("Error closing imprest: " + imp.statusText);
              }
            } catch (error) {
              console.error("Error updating imprest:", error);
              alert("Error closing imprest: " + error.message);
            }
          } else {
            await getExpansee();
            await getAllempdata();
            setFormData({
              name: "",
              imprest: "",
              date: formattedDate,
              empcode: sessionStorage.getItem("emp_code"),
            });
            handleClose();
          }
        } else {
          console.log("Expense Creation Error");
        }
      } catch (err) {
        handleAllError(err, loadingToastId);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  useEffect(() => {
    getAllempdata();
  }, [imprestExist]);

  const [buffer1, setBuffering1] = useState(true);
  const [departmentLists, setDepartmentLists] = useState([]);
  const getDepartments = async () => {
    try {
      setBuffering1(true);
      const dep = await axios.get(
        `${BASE_URL}/wfm/departmentfilterbysubcompanycount/${sessionStorage.getItem("company_id") || "null"}/active/`,
      );
      setDepartmentLists(dep.data);
    } catch (err) {
    } finally {
      setBuffering1(false);
    }
  };

  const [allemployeeImprest, setAllemployeeImprest] = useState([]);
  const [allemployeedata, setAllemployee] = useState([]);

  const getAllempdata = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/wfm/imprestbyemployeedetails/${sessionStorage.getItem("emp_code")}/`,
      );
      setAllemployeeImprest(res.data);

      const emp = await axios.get(
        PERMISSION_AUTHORITY
          ? `${BASE_URL}/wfm/ourcompanyempdetailsactive/null/`
          : `${BASE_URL}/wfm/ourcompanyempdetailsactive/${sessionStorage.getItem("company_id")}/`,
      );

      const sortedList = customSortByKey(emp.data, "emp_code");
      setAllemployee(sortedList);
    } catch (err) {
      handleErrorToast(err);
    }
  };

  const [projectList, setProjectList] = useState([]);
  const [buffer, setBuffering] = useState(false);

  const getFilterProjects = async (department) => {
    setBuffering(true);
    try {
      // Always fetch ALL projects for this sub_company (no department filter on API)
      // const url = `${BASE_URL}/mantra_projects/projects/?sub_company_id=${toggleCompany}`;
      const url = `${BASE_URL}/mantra_projects/projects/short-data/${toggleCompany}/`;
      const res = await axios.get(url);
      const data = res.data || [];
      // const data = res.data?.results || [];
      setAllProjectList(data); //  store full list

      //  Filter client-side if department is selected
      if (department) {
        const filtered = data.filter(
          (p) => p.department === department || p.department === null,
        );
        setProjectList(filtered);
      } else {
        setProjectList(data);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  const options = allemployeedata
    .sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
    .map((e) => ({
      value: e.emp_code,
      label: `${e.emp_code} - ${e.name}`,
    }));

  const handleChangecc = (selected) => {
    const multipleperson =
      selected.length > 0 ? selected.map((item) => item.value) : "";
    setSelectedOptions(selected);

    setFormData((prevState) => ({
      ...prevState,
      multipleperson,
      person: selected.length > 0 ? selected.length : "", // Map person count to clear validation
    }));

    // Clear validation error when selection is made
    if (selected.length > 0) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors.person;
        return updatedErrors;
      });
    }
  };

  const handleProjectChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        mantra_project_id: "",
        project_name: "",
        ref_project_code: "",
        ref_project_name: "",
      });
      return;
    }

    const selectedProject = projectList.find(
      (project) => project.project_code === selectedOption.value,
    );

    if (selectedProject) {
      const fullProjectName = `${selectedProject.project_code}-${selectedProject.project_short_name}`;

      setFormData({
        ...formData,
        mantra_project_id: selectedProject.id,
        project_name: fullProjectName,
        ref_project_code: selectedProject.project_code,
        ref_project_name: selectedProject.project_short_name,
      });

      setInputState({
        ...inputState,
        mantra_project_id: "green",
        project_name: "green",
        ref_project_code: "green",
        ref_project_name: "green",
      });
    }
  };

  const [newProject, setNewProject] = useState(false);

  const getImprestTypeFormat = async () => {
    try {
      setBuffering(true);
      const res = await axios.get(
        `${BASE_URL}/wfm/imprest_type_format_subcompany/${toggleCompany}/`,
      );

      const formattedFormatData = res.data.map((item) => ({
        other_name: item.other_name || "",
        amount: item.amount || 0,
        approved_other: item.approved_other || 0,
      }));

      setFormData({
        ...formData,
        other_details: formattedFormatData,
      });
    } catch (error) {
      console.error(error);
    } finally {
      setBuffering(false);
    }
  };

  const projectOptions = projectList.map((data) => ({
    value: data.project_code,
    label: `${data.project_code} - ${data.project_short_name}`,
  }));

  // Reusable responsive inline styles to fix layout bugs
  const rowStyle = {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-start",
    gap: "20px",
    width: "100%",
    marginBottom: "15px",
  };

  const colHalfStyle = {
    flex: "1 1 calc(50% - 10px)",
    minWidth: "250px",
    display: "flex",
    flexDirection: "column",
    boxSizing: "border-box",
  };

  const colFullStyle = {
    flex: "1 1 100%",
    display: "flex",
    flexDirection: "column",
  };

  const inputStyle = {
    width: "auto",
    marginTop: "5px",
    boxSizing: "border-box",
  };

  return (
    <>
      <button className="upload-svg" onClick={handleShow} style={{margin: '0'}}>
        <AddwithWhiteCircle /> Expense
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName={
          imprestExist === "No Imprest"
            ? "ourcompany-model"
            : "request-leave width-40vw"
        }
      >
        <Modal.Body style={{ padding: "30px" }}>
          <div
            className="parent-div"
            style={{ width: "100%", boxSizing: "border-box" }}
          >
            <div
              className="leave-duration-tabs"
              style={{
                width: "100%",
                position: "relative",
                display: "flex",
                marginBottom: "40px",
                cssText: "box-sizing: border-box !important;",
              }}
            >
              <input
                type="radio"
                id="imprest-existing"
                name="imprest_exist"
                value="Existing Imprest"
                checked={imprestExist === "Existing Imprest"}
                onChange={(e) => setImprestExist(e.target.value)}
                hidden
              />
              <label
                htmlFor="imprest-existing"
                className="leave-tab"
                style={{
                  flex: 1,
                  textAlign: "center",
                  cursor: "pointer",
                  padding: "10px",
                  margin: 0,
                }}
              >
                Existing Imprest
              </label>

              <input
                type="radio"
                id="imprest-no"
                name="imprest_exist"
                value="No Imprest"
                checked={imprestExist === "No Imprest"}
                onChange={(e) => setImprestExist(e.target.value)}
                hidden
              />
              <label
                htmlFor="imprest-no"
                className="leave-tab"
                style={{
                  flex: 1,
                  textAlign: "center",
                  cursor: "pointer",
                  padding: "10px",
                  margin: 0,
                }}
              >
                No Imprest
              </label>

              <span
                className="leave-tab-glider"
                style={{
                  transform:
                    imprestExist === "Existing Imprest"
                      ? "translateX(0%)"
                      : "translateX(100%)",
                  width: "50%",
                  position: "absolute",
                  bottom: 0,
                  height: "3px",
                  background: "#2576bc",
                  transition: "transform 0.3s ease",
                }}
              ></span>
            </div>

            {/* MAIN FORM CONTAINER */}
            <div
              className="form-flex-wrap"
              style={{ width: "100%", padding: "20px 0px" }}
            >
              {/* === EXISTING IMPREST LAYOUT === */}
              {imprestExist === "Existing Imprest" && (
                <div style={rowStyle}>
                  <div style={colHalfStyle}>
                    <label
                      htmlFor="name"
                      className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                    >
                      Expense Name<span className="required">*</span>
                    </label>
                    <input
                      id="name"
                      type="text"
                      name="name"
                      placeholder="Expense Name"
                      onChange={handleInputChange}
                      value={formData.name}
                      className={`form-input ${
                        errors.name ? "error" : inputState.name ? "success" : ""
                      }`}
                      style={inputStyle}
                    />
                    {errors.name && (
                      <span className="error-message font-size-text ">
                        {errors.name}
                      </span>
                    )}
                  </div>

                  <div style={colHalfStyle}>
                    <label className="form-labels font-weight500 announce-date font-weight400 font-size-heading">
                      Against Imprest<span className="required">*</span>
                    </label>

                    {/* Replaced native select with React Select to fix clipping */}
                    <div style={{ width: "100%", marginTop: "5px" }}>
                      <Select
                        name="imprest"
                        placeholder="Select Imprest"
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        value={allemployeeImprest
                          .filter((imprest) => imprest.imprest_open === true)
                          .map((e) => ({
                            value: e.id,
                            label: `${e.project_name} - ${formattedDateLong(e.date)}`,
                          }))
                          .find((option) => option.value === formData.imprest)}
                        options={allemployeeImprest
                          .filter((imprest) => imprest.imprest_open === true || imprest.imprest_open === false)
                          .map((e) => {
                            const imprestDate = new Date(
                              e.apply_datetime || e.date,
                            );
                            const today = new Date();
                            const timeDiff = today - imprestDate;
                            const daysPassed = Math.floor(
                              timeDiff / (1000 * 60 * 60 * 24),
                            );
                            let submissionNote = "";

                            if (PORTAL_SETTINGS?.expense_submit_limit) {
                              const limit =
                                PORTAL_SETTINGS.expense_submit_limit_days;
                              if (daysPassed < limit) {
                                const daysRemaining = limit - daysPassed;
                                submissionNote = `(${daysRemaining} day${daysRemaining > 1 ? "s" : ""} left)`;
                              } else if (daysPassed === limit) {
                                submissionNote = `(Last day to submit)`;
                              } else {
                                const daysLate = daysPassed - limit;
                                submissionNote = `(${daysLate} day${daysLate > 1 ? "s" : ""} late)`;
                              }
                            }

                            return {
                              value: e.id,
                              label: `${e.project_name} - ${formattedDateLong(e.date)} ${submissionNote}`,
                            };
                          })}
                        onChange={(selected) =>
                          handleInputChange({
                            target: {
                              name: "imprest",
                              value: selected ? selected.value : "",
                            },
                          })
                        }
                        styles={{
                          ...CSSForSelect,
                          control: (base) => ({
                            ...base,
                            width: "100%",
                            minHeight: "50px",
                            borderRadius: "10px",
                            backgroundColor: "#f7f8fa",
                            border: errors.imprest
                              ? "1px solid #dc3545"
                              : "1px solid #e3e3e3",
                          }),
                          menu: (base) => ({
                            ...base,
                            width: "100%",
                            maxWidth: "100%",
                            overflow: "hidden",
                          }),
                          option: (base) => ({
                            ...base,
                            whiteSpace: "normal",
                            overflowWrap: "anywhere",
                            wordBreak: "break-word",
                          }),
                          menuList: (base) => ({
                            ...base,
                            maxWidth: "100%",
                            overflowX: "hidden",
                          }),
                          menuPortal: (base) => ({
                            ...base,
                            zIndex: 9999,
                            maxWidth: "100vw",
                          }),
                        }}
                      />
                    </div>
                    {errors.imprest && (
                      <span
                        className="error-message font-size-text"
                        style={{ marginTop: "5px", display: "block" }}
                      >
                        {errors.imprest}
                      </span>
                    )}
                  </div>
                </div>
              )}

              {/* === NO IMPREST LAYOUT === */}
              {imprestExist === "No Imprest" && (
                <>
                  <div style={rowStyle}>
                    <div style={colHalfStyle}>
                      <label
                        htmlFor="project_name"
                        className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                      >
                        Imprest Name<span className="required">*</span>
                      </label>
                      {buffer ? (
                        <div className="form-loader" style={inputStyle}>
                          <div className="bar-loader"></div>
                        </div>
                      ) : (
                        <>
                          <input
                            id="project_name"
                            type="text"
                            name="project_name"
                            placeholder="Imprest Name"
                            onChange={handleInputChange}
                            value={formData.project_name}
                            className={`form-input ${
                              errors.project_name
                                ? "error"
                                : inputState.project_name
                                  ? "success"
                                  : ""
                            }`}
                            style={inputStyle}
                          />
                          {errors.project_name && (
                            <span className="error-message font-size-text ">
                              {errors.project_name}
                            </span>
                          )}
                        </>
                      )}
                    </div>

                    <div style={colHalfStyle}>
                      <label
                        htmlFor="name"
                        className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                      >
                        Expense Name<span className="required">*</span>
                      </label>
                      <input
                        id="name"
                        type="text"
                        name="name"
                        placeholder="Expense Name"
                        onChange={handleInputChange}
                        value={formData.name}
                        className={`form-input ${
                          errors.name
                            ? "error"
                            : inputState.name
                              ? "success"
                              : ""
                        }`}
                        style={inputStyle}
                      />
                      {errors.name && (
                        <span className="error-message font-size-text ">
                          {errors.name}
                        </span>
                      )}
                    </div>
                  </div>

                  <div style={rowStyle}>
                    <div style={colHalfStyle}>
                      <label
                        htmlFor="date"
                        className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                      >
                        Date<span className="required">*</span>
                      </label>
                      <input
                        id="date"
                        type="date"
                        name="date"
                        onChange={handleInputChange}
                        value={formData.date}
                        className={`form-input ${
                          errors.date
                            ? "error"
                            : inputState.date
                              ? "success"
                              : ""
                        }`}
                        style={inputStyle}
                      />
                      {errors.date && (
                        <span className="error-message font-size-text ">
                          {errors.date}
                        </span>
                      )}
                    </div>

                    <div style={colHalfStyle}>
                      <label
                        htmlFor="imprest_type"
                        className="form-labels font-weight500 announce-date"
                      >
                        Imprest Type<span className="required">*</span>
                      </label>
                      <select
                        name="imprest_type"
                        onChange={(e) => handleImprestTypeChange(e)}
                        value={formData.imprest_type}
                        className={`form-input`}
                        style={inputStyle}
                      >
                        <option value="">Select Type of Imprest</option>
                        <option value="non-project-related">
                          Not Related to a Project
                        </option>
                        <option value="project-related">Project Related</option>
                      </select>
                      {errors.imprest_type && (
                        <span
                          className="error-message font-size-text"
                          style={{ marginTop: "5px", display: "block" }}
                        >
                          {errors.imprest_type}
                        </span>
                      )}
                    </div>
                  </div>

                  {formData.imprest_type === "project-related" && (
                    <>
                      <div style={rowStyle}>
                        <div style={colHalfStyle}>
                          <label
                            htmlFor="department"
                            className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                          >
                            Department
                          </label>
                          {buffer1 ? (
                            <div className="form-loader" style={inputStyle}>
                              <div className="bar-loader"></div>
                            </div>
                          ) : (
                            <select
                              name="department"
                              onChange={(e) => handleDepartmentChange(e)}
                              value={formData.department}
                              className={`form-input-date`}
                              style={inputStyle}
                            >
                              <option value="">
                                Select Department for Projects
                              </option>
                              {sessionStorage.getItem("company_id") ===
                              "025d0b52-e892-4868-a3bb-6b70dcdffb4d" ? (
                                <option value="Prebid">Prebid</option>
                              ) : null}
                              {departmentLists
                                .sort((a, b) => a.title.localeCompare(b.title))
                                .map((i) => (
                                  <option key={i.id} value={i.id}>
                                    {i.title}
                                  </option>
                                ))}
                            </select>
                          )}
                          {errors.department && (
                            <span className="error-message font-size-text">
                              {errors.department}
                            </span>
                          )}
                        </div>

                        <div style={colHalfStyle}>
                          <label
                            htmlFor="ref_project_code"
                            className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                          >
                            For{" "}
                            {departmentLists.find(
                              (t) => t.id === formData.department,
                            )?.title || ""}{" "}
                            Project <span className="required">*</span>
                          </label>

                          {buffer ? (
                            <div className="form-loader" style={inputStyle}>
                              <div className="bar-loader"></div>
                            </div>
                          ) : (
                            <div style={{ width: "100%", marginTop: "5px" }}>
                              <CreatableSelect
                                id="ref_project_code"
                                name="ref_project_code"
                                options={projectOptions}
                                onChange={handleProjectChange}
                                value={
                                  formData.ref_project_code
                                    ? {
                                        value: formData.ref_project_code,
                                        label:
                                          projectOptions.find(
                                            (o) =>
                                              o.value ===
                                              formData.ref_project_code,
                                          )?.label || formData.ref_project_code,
                                      }
                                    : null
                                }
                                placeholder="Project Code"
                                isClearable
                                noOptionsMessage={() =>
                                  projectList.length === 0
                                    ? "No projects found. Contact Admin to add project."
                                    : "No matching project"
                                }
                                styles={{
                                  ...CSSForSelectAutoSize,
                                  control: (base) => ({
                                    ...base,
                                    width: "100%",
                                    minHeight: "50px",
                                    borderRadius: "10px",
                                    backgroundColor: "#f7f8fa",
                                    border: "1px solid #e3e3e3",
                                  }),
                                }}
                              />
                            </div>
                          )}
                          {projectList.length === 0 && !buffer && (
                            <span
                              className="form-hint font-size-text"
                              style={{ color: "#888", marginTop: "4px" }}
                            >
                              No projects found. Please contact Admin.
                            </span>
                          )}
                          {errors.ref_project_code && (
                            <span className="error-message font-size-text">
                              {errors.ref_project_code}
                            </span>
                          )}
                        </div>
                      </div>

                      <div style={rowStyle}>
                        <div style={colFullStyle}>
                          <label
                            htmlFor="ref_project_name"
                            className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                          >
                            Project Name<span className="required">*</span>
                          </label>
                          {buffer ? (
                            <div className="form-loader" style={inputStyle}>
                              <div className="bar-loader"></div>
                            </div>
                          ) : (
                            <input
                              id="ref_project_name"
                              type="text"
                              name="ref_project_name"
                              placeholder="Auto-filled on project selection"
                              readOnly
                              style={{
                                ...inputStyle,
                                cursor: "not-allowed",
                                backgroundColor: "#f5f5f5",
                              }}
                              value={formData.ref_project_name}
                              className={`form-input ${
                                errors.ref_project_name
                                  ? "error"
                                  : inputState.ref_project_name
                                    ? "success"
                                    : ""
                              }`}
                            />
                          )}
                          {errors.ref_project_name && (
                            <span className="error-message font-size-text">
                              {errors.ref_project_name}
                            </span>
                          )}
                        </div>
                      </div>
                    </>
                  )}

                  <div style={{ width: "100%", margin: "15px 0" }}>
                    <hr className="line" />
                  </div>

                  {formData.other_details.length > 0 && (
                    <div style={rowStyle}>
                      {formData.other_details.map((other, index) => (
                        <div
                          style={colHalfStyle}
                          key={`other_details_${index}`}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <label
                              htmlFor={`other_name_${index}`}
                              className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                            >
                              Expense Name
                            </label>
                            {index !== 0 && (
                              <button
                                type="button"
                                title="Remove"
                                className="action-div m-0"
                                onClick={() => handleRemoveOthers(index)}
                                style={{
                                  background: "transparent",
                                  border: "none",
                                  padding: 0,
                                }}
                              >
                                <CrosswithRedCircle />
                              </button>
                            )}
                          </div>
                          <input
                            id={`other_name_${index}`}
                            type="text"
                            name="other_name"
                            placeholder="Other Expense Name"
                            onChange={(e) => handleOtherInputChange(index, e)}
                            value={other.other_name}
                            className={`form-input`}
                            style={inputStyle}
                          />
                        </div>
                      ))}
                    </div>
                  )}

                  <div style={rowStyle}>
                    <button
                      type="button"
                      title="Add Expense"
                      className="flex-row jd-heading-main font-weight600 gap-2 align-items-center"
                      onClick={handleAddOthers}
                      style={{
                        background: "transparent",
                        border: "none",
                        padding: 0,
                      }}
                    >
                      <AddwithBlueCircle />{" "}
                      <span className="w-max-content">Add Expense Type</span>
                    </button>
                  </div>

                  <div style={{ width: "100%", margin: "15px 0" }}>
                    <hr className="line" />
                  </div>

                  <div style={rowStyle}>
                    <div style={colHalfStyle}>
                      <label
                        htmlFor="no_of_days"
                        className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                      >
                        Number of days<span className="required">*</span>
                      </label>
                      <input
                        id="no_of_days"
                        type="number"
                        min={0}
                        placeholder="Days"
                        name="no_of_days"
                        onWheel={(e) => e.target.blur()}
                        onChange={handleInputChange}
                        value={formData.no_of_days}
                        className={`form-input ${
                          errors.no_of_days
                            ? "error"
                            : inputState.no_of_days
                              ? "success"
                              : ""
                        }`}
                        style={inputStyle}
                      />
                      {errors.no_of_days && (
                        <span className="error-message font-size-text ">
                          {errors.no_of_days}
                        </span>
                      )}
                    </div>

                    <div style={colHalfStyle}>
                      <label
                        htmlFor="person"
                        className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                      >
                        Name of Person<span className="required">*</span>
                      </label>
                      <div style={{ width: "100%", marginTop: "5px" }}>
                        <Select
                          options={options}
                          isMulti
                          value={selectedOptions}
                          onChange={handleChangecc}
                          styles={{
                            ...CSSForSelect,
                            control: (base) => ({
                              ...base,
                              width: "100%",
                              minHeight: "50px",
                              borderRadius: "10px",
                              backgroundColor: "#f7f8fa",
                              border: "1px solid #e3e3e3",
                            }),
                          }}
                        />
                      </div>
                      {errors.person && (
                        <span
                          className="error-message font-size-text"
                          style={{ marginTop: "5px", display: "block" }} // <-- Add this inline style
                        >
                          {errors.person}
                        </span>
                      )}
                    </div>
                  </div>

                  <div style={rowStyle}>
                    <div style={colHalfStyle}>
                      <label
                        htmlFor="person_count"
                        className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                      >
                        Number's of Person (Auto)
                      </label>
                      <input
                        id="person_count"
                        type="number"
                        name="person_count"
                        readOnly
                        value={formData.multipleperson?.length || 0}
                        className={`form-input ${
                          errors.person
                            ? "error"
                            : inputState.person
                              ? "success"
                              : ""
                        }`}
                        style={{ ...inputStyle, backgroundColor: "#f5f5f5" }}
                      />
                    </div>
                    <div style={colHalfStyle}>
                      <label
                        htmlFor="remarks"
                        className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                      >
                        Remarks
                      </label>
                      <textarea
                        id="remarks"
                        name="remarks"
                        placeholder="Your feedback"
                        onChange={handleInputChange}
                        value={formData.remarks}
                        className={`form-input-textarea font-weight400 font-size-subheading ${
                          errors.remarks
                            ? "error"
                            : inputState.remarks
                              ? "success"
                              : ""
                        }`}
                        style={{
                          ...inputStyle,
                          height: "100px",
                          resize: "vertical",
                          padding: "10px",
                        }}
                      />
                      {errors.remarks && (
                        <span className="error-message font-size-text ">
                          {errors.remarks}
                        </span>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>

            <div className="button-models">
              <button
                className="model-button model-button-cancel   font-weight500   "
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                onClick={handleFormSubmit}
                disabled={loading}
              >
                Add
              </button>
            </div>

            <div
              className="error-message font-size-text"
              style={{ textAlign: "right", marginTop: "10px" }}
            >
              {isSubmitted &&
                Object.keys(errors).length > 0 &&
                (Object.keys(errors).length > 5 ? (
                  <span style={{ color: "#d9534f" }}>
                    Please fill all mandatory fields!
                  </span>
                ) : (
                  <span style={{ color: "#d9534f" }}>
                    {Object.keys(errors)
                      .map((field) =>
                        field
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (char) => char.toUpperCase()),
                      )
                      .join(", ") + " are required!"}
                  </span>
                ))}
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar={false}
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

export { ExpenseAdd };
